import { render, staticRenderFns } from "./StatisticResult.vue?vue&type=template&id=08c1328e"
import script from "./StatisticResult.vue?vue&type=script&lang=js"
export * from "./StatisticResult.vue?vue&type=script&lang=js"
import style0 from "./StatisticResult.vue?vue&type=style&index=0&id=08c1328e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports